import Control, { ControlDashboard } from './control';
import Risk from './risk';

export default class Risks {
  risks: Risk[];

  constructor() {
    this.risks = [];
  }

  forEach(callback: (item: Risk) => void) {
    for (const item of this.risks) {
      callback(item);
    }
  }
}

export class RiskDashboard {
  controls: Control[] = [];

  controlDashboards: ControlDashboard[] = [];

  aggregatedDashboard: ControlDashboard | undefined;

  previousPeriod: RiskDashboardPeriod | undefined;
}

export class RiskDashboardPeriod {
  startDate: Date | undefined;

  endDate: Date | undefined;

  controlDashboards: ControlDashboard[] = [];

  aggregatedDashboard: ControlDashboard | undefined;
}
